import { render, staticRenderFns } from "./MonthlyStats.vue?vue&type=template&id=06b6fea4&scoped=true&"
import script from "./MonthlyStats.vue?vue&type=script&lang=js&"
export * from "./MonthlyStats.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyStats.vue?vue&type=style&index=0&id=06b6fea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b6fea4",
  null
  
)

export default component.exports